.page {
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--sp-6);
  background: var(--bg);
}

.card {
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
  width: min(420px, 100%);
  padding: var(--sp-7);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--surface);
  box-shadow: var(--shadow-card);
}

.title {
  margin: 0;
  font-size: var(--fs-xl);
  font-weight: 600;
  color: var(--text);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}

.form .btn {
  margin-top: var(--sp-3);
}

.hint {
  margin: 0;
  font-size: var(--fs-sm);
  color: var(--text-3);
  line-height: 1.4;
}

.notice {
  margin: 0;
  padding: var(--sp-4) var(--sp-5);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
  background: var(--surface-sunken);
  color: var(--text-2);
  font-size: var(--fs-md);
}

.error {
  margin: 0;
  padding: var(--sp-4) var(--sp-5);
  border: var(--bw) solid var(--error-border);
  border-radius: var(--radius);
  background: var(--error-bg);
  color: var(--error);
  font-size: var(--fs-md);
}

.errorList {
  margin: var(--sp-2) 0 0;
  padding-left: var(--sp-6);
}
